var types = ['EXCHANGE_CLAIM', 'EXCHANGE_CLAIM_SUCCESS', 'EXCHANGE_CLAIM_ERROR', 'GENERATE_CLAIM', 'GENERATE_CLAIM_SUCCESS', 'GENERATE_CLAIM_ERROR'];
var creators = function creators(duck) {
  return {
    exchangeClaim: function exchangeClaim(payload) {
      return Object.assign({
        type: duck.types.EXCHANGE_CLAIM
      }, payload);
    },
    generateClaim: function generateClaim(payload) {
      return Object.assign({
        type: duck.types.GENERATE_CLAIM
      }, payload);
    }
  };
};

export { creators, types };
//# sourceMappingURL=actions.js.map
